import classnames from 'classnames'
import React, { useState, useEffect, useCallback, useRef } from 'react'

import { LANDING_PAGE_PREVIEW_HEIGHT } from '../../config'
import PropTypesHelpers from '../../utils/propTypesHelpers'

const LandingPageContentCollapsible = ({ children }) => {
  const [previewEnabled, setPreviewMode] = useState(false)
  const [collapsed, setCollapsed] = useState(true)

  const handleCollapseClick = useCallback((event) => {
    event.preventDefault()
    setCollapsed(!collapsed)
  }, [collapsed])

  const contentRef = useRef()

  const resizeListener = useCallback(() => {
    setPreviewMode(contentRef.current.scrollHeight > LANDING_PAGE_PREVIEW_HEIGHT)
  }, [])

  useEffect(() => {
    window.addEventListener('resize', resizeListener)
    resizeListener()
    return () => {
      window.removeEventListener('resize', resizeListener)
    }
  }, [resizeListener])

  return (
    <div className='landing-page-collapsible'>
      <div ref={contentRef} className={classnames({ 'preview qa-lp-pv': previewEnabled }, { 'collapsed qa-lp-pv-c': collapsed })}>
        <div>{children}</div>
      </div>
      {previewEnabled &&
        <button
          type='button' className={classnames('landing-page-collapsible__button qa-lp-pv-c-btn')}
          onClick={handleCollapseClick}
        >
          {collapsed ? 'mehr' : 'weniger'}
        </button>}
    </div>
  )
}

LandingPageContentCollapsible.propTypes = {
  children: PropTypesHelpers.children.isRequired
}

export default LandingPageContentCollapsible
